module.exports = __webpack_public_path__ + "img/furukawa.7c95cd18.svg";